import type { Language } from '@eformulieren/engine'
import type { Event } from '@eformulieren/model'

/**
 * Wat de pagina zegt nadat deze kijker een beurt heeft gesloten (R-173, R-181, R-86).
 *
 * **Het formulier blijft staan.** Na een geslaagde overdracht haalt de pagina de projectie
 * opnieuw op; de instantie is dan bevroren, dus de gedaante wordt `nalezen` en elke sectie
 * alleen-lezen (`gedaante.ts`, `rolRecht` in de engine). Wat er stond, staat er nog, en deze zin
 * zegt erbij wat er is gebeurd. Een leeg formulier na het sluiten zou er hetzelfde uitzien als
 * een formulier waarvan de gegevens weg zijn (valkuil 6).
 *
 * De drie toetsuitkomsten heten zoals R-181 en de tabel van ontwerp 7.3 ze noemen. Wat er daarna
 * gebeurt is aan het processysteem (R-194, R-195): het product zet geen volgende beurt klaar en
 * stuurt niemand een bericht, dus deze zin belooft dat ook niet.
 */
const NOTICE: Record<Event, Record<Language, string>> = {
  ingediend: {
    nl: 'Ingediend. Het formulier is alleen nog na te lezen.',
    en: 'Submitted. This turn is closed; the form can only be read.',
  },
  'opnieuw-ingediend': {
    nl: 'Opnieuw ingediend. Het formulier is alleen nog na te lezen.',
    en: 'Resubmitted. This turn is closed; the form can only be read.',
  },
  aangevuld: {
    nl: 'Aangevuld. Het formulier is alleen nog na te lezen.',
    en: 'Supplemented. This turn is closed; the form can only be read.',
  },
  teruggelegd: {
    nl: 'Teruggelegd naar de aanvrager, die de aanvraag nu kan aanpassen. Het formulier is alleen nog na te lezen.',
    en: 'Returned for correction: the check is closed with the outcome opportunity to correct. The form can only be read.',
  },
  goedgekeurd: {
    nl: 'Goedgekeurd: de aanvraag wordt in behandeling genomen. Het formulier is alleen nog na te lezen.',
    en: 'Approved: the check is closed with the outcome accepted for processing. The form can only be read.',
  },
  afgekeurd: {
    nl: 'Afgekeurd: de aanvraag wordt definitief niet in behandeling genomen. Het formulier is alleen nog na te lezen.',
    en: 'Rejected: the check is closed with the outcome definitively not accepted for processing. The form can only be read.',
  },
}

export function closedNotice(event: Event, language: Language): string {
  return NOTICE[event][language]
}
